<script>
  import Dropdown from "../shared/dropdown.svelte"
  import LoginModal from "./login-modal.svelte"
  import {load,save} from "../shared/api.js"
  export let userid = null;
  let open = null
  const signout = async ()=>{
    let result = (await load({ url:"/duocms/api/logout"})).data
    window.location.reload()
  }

  const signin = ()=>{
    open = true
  }
</script>

{#if userid}
  
  <Dropdown class="pull-right">
    <button class="btn btn-default btn-sm">Account</button>
    <div slot="menu">
      <li><a href="/system/change_password/" target="_self">Update My Password</a></li>
      <li><a href="/system/mydetails/" target="_self">Update My Details</a></li>
      <li><button on:click={signout}>Sign Out</button></li>
      <slot></slot>
    </div>
  </Dropdown>
{:else}
  <button class="btn btn-default btn-sm signinbutton" on:click={signin} >Sign In</button>
  <LoginModal bind:open={open} />
{/if}